import React from 'react';
import IconButton from '../../../../common/IconButton';
import { BiRupee } from 'react-icons/bi';
import { buyCourse } from '../../../../../services/operations/buyCourseApi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const TotalAmount = ({ total, wishlist }) => {
    const { user } = useSelector(state => state.profile);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handlerBuyCourse = () => {
        const courses = wishlist.map((course) => course?._id);
        buyCourse(courses, user, navigate, dispatch);
    }

    return (
        <div className='sm:min-w-[280px] wishlist-checkout-btn min-w-[200px] flex items-center gap-5 rounded-md border-[1px] border-richblue-700 bg-richblack-800 sm:px-6 py-6 px-4 h-fit'>
            <p className='font-medium text-richblack-300'>
                Total:
            </p>
            <p className='text-3xl flex items-center font-medium text-yellow-100'>
                <span><BiRupee /></span>
                <span>{total?.toLocaleString()}</span>
            </p>
            <IconButton
                text='Buy Now'
                onClick={handlerBuyCourse}
                customClasses={'flex items-center bg-yellow-50 cursor-pointer rounded-md py-2 px-5 font-semibold text-richblack-900 w-full justify-center'}
            />
        </div>
    );
}

export default TotalAmount;